import styled from 'styled-components';

/* Footer wrapper */
export const FooterSection = styled.footer.attrs(props => ({
  id: props.id || 'footer',
}))`
  background: #0a0a0a;
  padding: 40px 0 20px 0;
  text-align: center;
  color: #f8f4f4;
  border-top: 2px solid #0ff;
  box-shadow: inset 0 0 50px rgba(0, 255, 255, 0.2);

  .footercontainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin: 0 auto;
    padding: 0 20px;
    max-width: 900px;
  }

  p {
    font-size: 0.9rem;
    color: #0ff;
    margin-top: 10px;
    text-shadow: 0 0 5px #0ff, 0 0 10px #0ff80;
  }

  /* Flex container for icons to stay in one row */
  .icon-row {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: nowrap; /* prevent wrapping */
  }

  @media (max-width: 480px) {
    p {
      font-size: 0.8rem;
    }
  }
`;

/* Individual icons */
export const StyledIcon = styled.a`
  font-size: 40px;
  color: #0ff;
  text-decoration: none;
  transition: all 0.3s ease;
  filter: drop-shadow(0 0 5px #0ff);

  &:hover {
    color: #ff007f;
    transform: scale(1.2) rotate(-5deg);
    text-shadow: 0 0 10px #ff007f, 0 0 20px #ff00bf;
  }

  @media (max-width: 480px) {
    font-size: 30px;
  }
`;
